
import React, {
  useState,
  useEffect,
} from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Table,
  Row,
  Col,
} from "reactstrap";
import axios from "../../../utills/api";
import { toast } from "react-toastify";

const PaymentBreakdownModal = ({
  isOpen,
  toggle,
  paymentData,
}) => {
  const [discount, setDiscount] =
    useState(0);

  const [paymentMode, setPaymentMode] =
    useState("cash");

  const [receiveAmount, setReceiveAmount] =
    useState(0);

  const data =
    Array.isArray(paymentData)
      ? paymentData[0] || {}
      : paymentData || {};

  const booking =
    data.booking || data || {};

  console.log("CHECKOUT DATA", booking);

  const extraBedRequired =
    booking.extraBedRequired ||
    Number(data.charges?.extraBed || 0) > 0;


  // ==========================================
  // ROOM DETAILS (From Settlement API)
  // ==========================================

  const room = booking;

  const bookedNights = Number(
    room.bookedNights || 0
  );

  const chargeableNights = Number(
    room.chargeableNights || 0
  );

  const ratePerNight = Number(
    room.ratePerNight || 0
  );

  const gstRate = Number(
    room.gstRate || 0
  );

  const originalRoomCharge = Number(
    room.originalRoomCharge || 0
  );

  const revisedRoomCharge = Number(
    room.revisedRoomCharge || 0
  );

  const roomCharge = revisedRoomCharge;

  const originalTaxAmount = Number(
    room.originalTaxAmount || 0
  );

  const revisedTaxAmount = Number(
    room.revisedTaxAmount || 0
  );

  const taxAmount = revisedTaxAmount;

  const originalNetRoomCharge = Number(
    room.originalNetRoomCharge || 0
  );

  const revisedNetRoomCharge = Number(
    room.revisedNetRoomCharge || 0
  );

  const totalAmount =
    Number(
      booking.revisedTotalAmount ||
      booking.totalAmount ||
      0
    );

  // ==========================================
  // EXTENSION / REFUND
  // ==========================================
  const extensionAmount = Number(
    room.extensionAmount || 0
  );

  const refundAmount = Number(
    room.refundAmount || 0
  );

  // ==========================================
  // AUTOMATIC CHARGES
  // ==========================================

  const earlyCheckInCharge = Number(
    room.earlyCharge || 0
  );

  const lateCheckOutCharge = Number(
    room.lateCharge || 0
  );

  const halfDayCharge = Number(
    room.halfDayCharge || 0
  );

  const fullDayCharge = Number(
    room.fullDayCharge || 0
  );

  // ==========================================
  // PAYMENT
  // ==========================================

  const payment = booking;

  const actualTotalPaid = Number(
    payment.totalPaid || 0
  );

  const discountAmount = Number(
    payment.discountAmount || 0
  );

  const grossAmount = Number(
    payment.grossAmount || 0
  );

  const settlementAmount = Number(
    payment.settlementAmount || 0
  );

  const balanceDue = Number(
    payment.balanceDue || 0
  );

  const refundDue = Number(
    payment.refundDue || 0
  );

  const paymentStatus =
    booking.statusPayment ||
    "Unpaid";


  // ==========================================
  // SERVICES
  // ==========================================

  const services = booking;

  const foodTotal = Number(
    services.foodTotal || 0
  );

  const spaTotal = Number(
    services.spaTotal || 0
  );

  const wellnessTotal = Number(
    services.wellnessTotal || 0
  );

  const taxiTotal = Number(
    services.taxiTotal || 0
  );

  const kotTotal = Number(
    services.kotTotal || 0
  );

  const serviceAmount = Number(
    services.serviceAmount ||
    services.total ||
    booking.serviceAmount ||
    0
  );


  //////////////////////////////////
  // statusbar
  /////////////////////////////////

  useEffect(() => {
    if (!booking) return;

    setDiscount(
      Number(
        booking.discountAmount || 0
      )
    );

  }, [booking]);

  // ==========================================
  // AUTO SET RECEIVE AMOUNT
  // ==========================================

  useEffect(() => {
    if (!paymentData) return;

    setReceiveAmount(
      settlementAmount
    );

  }, [settlementAmount, paymentData]);

  // ==========================================
  // SAVE DISCOUNT
  // ==========================================

  const saveDiscount =
    async () => {
      if (!paymentData)
        return;

      try {
        await axios.put(
          `/bookings/${booking.bookingId}/discount`,
          {
            discountAmount:
              discount,
          }
        );

        toast.success(
          "Discount Saved"
        );
      } catch (err) {
        console.error(err);

        toast.error(
          "Failed to save discount"
        );
      }
    };

  useEffect(() => {
    if (
      !isOpen ||
      !paymentData
    )
      return;

    const timer =
      setTimeout(() => {
        saveDiscount();
      }, 800);

    return () =>
      clearTimeout(timer);
  }, [
    discount,
    isOpen,
    paymentData,
  ]);

  // ==========================================
  // RECEIVE PAYMENT
  // ==========================================

  const handleReceivePayment = async () => {
    try {

      // Receive Final Payment
      await axios.post(
        "/bookings/receive-payment",
        {
          bookingId: booking.bookingId,
          amount: receiveAmount,
          paymentMode,
          paymentType: "final",
        }
      );

      // Checkout Guest
      await axios.put(
        `/bookings/checkout/${booking.bookingId}`
      );

      toast.success(
        "Payment received and Guest Checked-Out Successfully"
      );

      toggle();

      window.location.reload();

    } catch (err) {

      console.error(err);

      toast.error(
        err?.response?.data?.message ||
        "Unable to checkout guest"
      );

    }
  };

  // IMPORTANT:
  // Return null only AFTER all hooks
  if (!paymentData) {
    return null;
  }

  const handleDirectCheckout = async () => {

    try {

      await axios.put(
        `/bookings/checkout/${paymentData.bookingId}`
      );


      toast.success(
        "Guest checked out successfully"
      );


      toggle();

      window.location.reload();


    } catch (err) {

      toast.error(
        "Checkout failed"
      );

    }

  };

  const handleRefundAndCheckout =
    async () => {

      try {
        await axios.post(
          "/bookings/receive-payment",
          {
            bookingId:
              paymentData.bookingId,
            amount:
              refundDue,
            paymentMode:
              "offline",
            paymentType:
              "refund"
          }
        );
        await axios.put(
          `/bookings/checkout/${paymentData.bookingId}`
        );
        toast.success(
          "Refund recorded and guest checked out"
        );
        toggle();

        window.location.reload();
      } catch (err) {
        console.error(err);
        toast.error(
          "Refund failed"
        );
      }


    };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="xl"
      centered
    >
      <ModalHeader toggle={toggle}>
        Payment Breakdown
      </ModalHeader>

      <ModalBody>
        {/* ========================================= */}
        {/* GUEST DETAILS */}
        {/* ========================================= */}

        <Row className="mb-4 g-3">

          <Col md={4}>
            <strong>Guest :</strong>
            <div>{booking.name}</div>
          </Col>

          <Col md={4}>
            <strong>Booking ID :</strong>
            <div>{booking.bookingId}</div>
          </Col>

          <Col md={4}>
            <strong>Room Type :</strong>
            <div>
              {booking.roomType || "-"}
            </div>
          </Col>

          <Col md={4}>
            <strong>Room Number :</strong>
            <div>
              {
                booking.assignedRoom?.roomNumber || "-" ||
                "-"}
            </div>
          </Col>

          <Col md={4}>
            <strong>Check-In :</strong>
            <div>
              {booking.checkIn
                ? new Date(booking.checkIn).toLocaleString("en-IN")
                : "-"
              }
            </div>
          </Col>

          <Col md={4}>
            <strong>Check-Out :</strong>
            <div>
              {booking.checkOut
                ? new Date(booking.checkOut).toLocaleString("en-IN")
                : "-"
              }
            </div>
          </Col>

        </Row>

        {/* ========================================= */}
        {/* SERVICES */}
        {/* ========================================= */}

        <h5 className="mb-3">
          Service Charges
        </h5>

        <Table bordered responsive>
          <thead>
            <tr>
              <th>Service</th>
              <th width="200">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Food Orders</td>
              <td>
                ₹
                {foodTotal.toLocaleString("en-IN")}
              </td>
            </tr>

            <tr>
              <td>KOT Orders</td>
              <td>
                ₹{kotTotal.toLocaleString("en-IN")}
              </td>
            </tr>

               <tr>
              <td>Spa Orders</td>
              <td>
                ₹{spaTotal.toLocaleString("en-IN")}
              </td>
            </tr>

            <tr className="table-info">
              <th>
                Total Service Amount
              </th>

              <th>
                ₹
                {serviceAmount.toLocaleString("en-IN")}
              </th>
            </tr>
          </tbody>
        </Table>



        {/* ========================================= */}
        {/* SUMMARY */}
        {/* ========================================= */}

        <h5 className="mt-5 mb-3">
          Payment Summary
        </h5>

        <Table bordered>
          <tbody>

            <tr>
              <th>Rate Per Night</th>
              <td>₹{ratePerNight.toLocaleString("en-IN")}</td>
            </tr>

            <tr>
              <th>Booked Nights</th>
              <td>{bookedNights}</td>
            </tr>

            <tr>
              <th>Chargeable Nights</th>
              <td>{chargeableNights}</td>
            </tr>

            <tr>
              <th>Original Room Charge</th>
              <td>₹{originalRoomCharge.toLocaleString("en-IN")}</td>
            </tr>

            <tr className="table-warning">
              <th>Revised Room Charge</th>
              <td>₹{revisedRoomCharge.toLocaleString("en-IN")}</td>
            </tr>

            <tr>
              <th>GST ({gstRate}%)</th>
              <td>₹{revisedTaxAmount.toLocaleString("en-IN")}</td>
            </tr>
            {extraBedRequired && extraBedAmount > 0 && (
              <tr className="table-warning">
                <th>
                  Extra Bed (
                  {extraBedCount} × ₹
                  {extraBedPrice.toLocaleString("en-IN")}
                  )
                </th>

                <td>
                  ₹
                  {extraBedAmount.toLocaleString("en-IN")}
                </td>
              </tr>
            )}

            <tr>
              <th>
                Service Amount
              </th>

              <td>
                ₹
                {serviceAmount.toLocaleString("en-IN")}
              </td>
            </tr>


            {extensionAmount > 0 && (
              <tr className="table-warning">
                <th>
                  Extension Amount
                </th>

                <td>
                  ₹
                  {extensionAmount.toLocaleString("en-IN")}
                </td>
              </tr>
            )}

            {earlyCheckInCharge > 0 && (
              <tr className="table-warning">
                <th>Early Check-In Charge</th>
                <td>
                  ₹{earlyCheckInCharge.toLocaleString("en-IN")}
                </td>
              </tr>
            )}

            {lateCheckOutCharge > 0 && (
              <tr className="table-warning">
                <th>Late Check-Out Charge</th>
                <td>
                  ₹{lateCheckOutCharge.toLocaleString("en-IN")}
                </td>
              </tr>
            )}

            {halfDayCharge > 0 && (
              <tr className="table-warning">
                <th>Half Day Charge</th>
                <td>
                  ₹{halfDayCharge.toLocaleString("en-IN")}
                </td>
              </tr>
            )}

            {fullDayCharge > 0 && (
              <tr className="table-danger">
                <th>Full Day Charge</th>
                <td>
                  ₹{fullDayCharge.toLocaleString("en-IN")}
                </td>
              </tr>
            )}

            {refundAmount > 0 && (
              <tr className="table-danger">
                <th>
                  Refund (Early Checkout)
                </th>

                <td>
                  ₹
                  {refundAmount.toLocaleString("en-IN")}
                </td>
              </tr>
            )}

            <tr className="table-info">
              <th>
                Gross Amount
              </th>

              <td>
                ₹
                {grossAmount.toLocaleString("en-IN")}
              </td>
            </tr>

            <tr>
              <th>
                Total Paid
              </th>

              <td>
                ₹
                {actualTotalPaid.toLocaleString("en-IN")}
              </td>
            </tr>

            <tr>
              <th>
                Amount Payable
              </th>

              <td className="text-danger fw-bold">

                ₹
                {balanceDue.toLocaleString("en-IN")}

              </td>
            </tr>
            <tr>

              <th>
                Refund Due
              </th>

              <td className="text-success fw-bold">
                ₹
                {refundDue.toLocaleString("en-IN")}

              </td>

            </tr>

            <tr>
              <th>
                Discount
              </th>

              <td>
                ₹
                {discountAmount.toLocaleString("en-IN")}
              </td>
            </tr>

            <tr className="table-success">

              <th>
                Settlement Amount
              </th>
              <th>

                {
                  settlementAmount > 0
                    ?
                    `₹${settlementAmount.toLocaleString("en-IN")} Payable`
                    :
                    settlementAmount < 0
                      ?
                      `₹${Math.abs(
                        settlementAmount
                      ).toLocaleString("en-IN")} Refund`
                      :
                      "Settled"
                }

              </th>
            </tr>
            <tr>
              <th>
                Payment Status
              </th>

              <th>
                {paymentStatus}
              </th>
            </tr>

          </tbody>
        </Table>

        {/* ========================================= */}
        {/* DISCOUNT */}
        {/* ========================================= */}

        <Row className="mt-4">

          <Col md={4}>
            <label>
              Discount Amount
            </label>

            <Input
              type="number"
              value={discount}
              onChange={(e) =>
                setDiscount(
                  Number(
                    e.target.value || 0
                  )
                )
              }
            />
          </Col>

          <Col
            md={2}
            className="d-flex align-items-end"
          >
          </Col>

        </Row>

        <div className="border rounded p-3 mt-4">

          <h5>
            Receive Payment
          </h5>

          <Row className="mt-3">

            <Col md={4}>
              <label>
                Amount
              </label>
              <Input
                type="number"
                value={
                  receiveAmount
                }
                onChange={(e) =>
                  setReceiveAmount(
                    Number(
                      e.target.value || 0
                    )
                  )
                }
              />
            </Col>

            <Col md={4}>
              <label>Payment Method</label>

              <Input
                type="select"
                value={paymentMode}
                onChange={(e) =>
                  setPaymentMode(
                    e.target.value
                  )
                }
              >
                <option value="cash">
                  Cash
                </option>

                <option value="upi">
                  UPI
                </option>

                <option value="card">
                  Card
                </option>

                <option value="bank">
                  Bank Transfer
                </option>
              </Input>
            </Col>

            <Col
              md={4}
              className="d-flex align-items-end"
            >
              {
                balanceDue > 0 ?

                  <Button
                    color="primary"
                    size="lg"
                    className="w-100"
                    disabled={
                      receiveAmount < balanceDue
                    }
                    onClick={handleReceivePayment}
                  >
                    Receive Payment & Check-Out
                  </Button>
                  :
                  refundDue > 0 ?

                    <Button
                      color="success"
                      size="lg"
                      className="w-100"
                      onClick={handleRefundAndCheckout}
                    >
                      Process Refund & Check-Out
                    </Button>

                    :

                    <Button
                      color="dark"
                      size="lg"
                      className="w-100"
                      onClick={handleReceivePayment}
                    >
                      Complete Check-Out
                    </Button>


              }
            </Col>

          </Row>

        </div>

      </ModalBody>

      <ModalFooter>
        <Button
          color="secondary"
          onClick={toggle}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PaymentBreakdownModal;